import { render, staticRenderFns } from "./TeacherStatus.vue?vue&type=template&id=f6c31c16"
import script from "./TeacherStatus.vue?vue&type=script&lang=js"
export * from "./TeacherStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports